import { ComponentType, ReactNode } from 'react'
import styled from 'styled-components'

import PlaceholderCard from '../../cards/PlaceholderCard'

const Wrapper = styled.div<{ $compact: boolean }>`
  margin: 0
    ${({ $compact }) => ($compact ? 'calc(var(--ds-space-05) / -2)' : '-14px')};
  overflow: hidden;
`

const Container = styled.div`
  display: flex;
`

const Slide = styled.div<{ $compact: boolean }>`
  padding: 0
    ${({ $compact }) => ($compact ? 'calc(var(--ds-space-05) / 2)' : '14px')};
  flex: 0 0 calc(100% / ${({ $compact }) => ($compact ? 5 : 3)});
  min-width: 0;
  box-sizing: border-box;
`

type SliderProps<T> = {
  items: T[]
  ItemComponent: ComponentType<{ item: T }>
  emblaRef: (node: HTMLDivElement | null) => void
  loadingPlaceholder: ReactNode
  slideCount: number
  compact?: boolean
}

const Slider = <T extends Record<'id', string>>({
  emblaRef,
  items,
  ItemComponent,
  loadingPlaceholder = <PlaceholderCard portrait={false} />,
  slideCount,
  compact = false,
}: SliderProps<T>) => (
  <Wrapper ref={emblaRef} $compact={compact}>
    <Container>
      {Array.from({ length: slideCount }, (_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Slide key={i} $compact={compact}>
          {i < items.length ? (
            <ItemComponent item={items[i]} />
          ) : (
            <>{loadingPlaceholder}</>
          )}
        </Slide>
      ))}
    </Container>
  </Wrapper>
)

export default Slider
